import styled from "styled-components";

const FnrRect = styled("rect")`
  stroke-width: 0px;
  fill: ${({ $virtue, $color, theme: { palette, colors } }) =>
    palette.icon[$virtue] || palette[$color] || colors[$color] || $color};
`;

export default FnrRect;
